"use client"

import { useState } from "react"

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null)

  const faqs = [
    {
      question: "How long does a custom order take?",
      answer:
        "Custom orders typically take 2-3 weeks to complete, depending on the complexity of the design and current order volume.",
    },
    {
      question: "What materials do you use?",
      answer:
        "We use high-quality epoxy resin, pigments, and various decorative elements to create our pieces. All materials are non-toxic and safe for home use.",
    },
    {
      question: "Do you ship internationally?",
      answer:
        "Currently, we ship within the United States. International shipping options are being developed and will be available soon.",
    },
    {
      question: "Can I return a custom piece?",
      answer:
        "Due to the personalized nature of custom orders, returns are only accepted if there are defects in craftsmanship. We work closely with you during the design process to ensure satisfaction.",
    },
    {
      question: "How do I care for my resin art?",
      answer:
        "Clean with a soft, damp cloth and avoid harsh chemicals. Keep away from direct sunlight for extended periods to prevent color fading.",
    },
  ]

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600">
            Common questions and answers about custom resin orders, shipping, and policies.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm">
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900">{faq.question}</span>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform ${openFAQ === index ? "rotate-180" : ""}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQSection
